import Client from "../client";
import ProjectManager from "@/entities/project-manager";
import ProjectManagerGateway from "@/gateways/project-manager-gateway";
import { ProjectId, StaffId } from "@/entities/ids";

export default class ProjectManagerApi implements ProjectManagerGateway {
  public constructor(private client: Client, private projectId: ProjectId) {}

  public async all() {
    const managers: ProjectManager[] = await this.client.get(
      "get_managers.php",
      { projectId: this.projectId }
    );
    return managers;
  }

  public async assigned() {
    return (await this.all()).filter(m => m.assigned);
  }

  public async unassigned() {
    return (await this.all()).filter(m => !m.assigned);
  }

  public async assign(id: StaffId) {
    const d = new FormData();
    d.append("staffId", String(id));
    d.append("projectId", String(this.projectId));
    await this.client.post("append_project_member.php", d);
  }

  public async unassign(id: StaffId) {
    const d = new FormData();
    d.append("staffId", String(id));
    d.append("projectId", String(this.projectId));
    await this.client.post("remove_project_member.php", d);
  }
}
